export const MIN_LOAN_AMOUNT = 500
export const MAX_LOAN_AMOUNT = 35000
export const MIN_LOAN_TERM = 12
export const MAX_LOAN_TERM = 84

export const MAX_SECURED_LOAN_AMOUNT = 100000
export const MAX_SECURED_LOAN_TERM = 360
